/*--------------------------------------------------------------
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * See License.txt in the project root for license information.
 *--------------------------------------------------------------*/

/* eslint-disable no-duplicate-imports */
import { getRichTextHtml } from '@msdyn365-commerce/core';
import * as React from 'react';

/**
 * Product application table row.
 */
export interface IProductApplicationTableRow {
    make?: string;
    model?: string;
    year?: string;
    cellData?: React.ReactNode;
    className?: string;
    qualifier?: string[];
    note?: string;
}
/**
 * Product application table row component.
 * @param props - For product application table row.
 * @param props.productName - Product name.
 * @param props.cellData - Cell data.
 * @param props.className - Class name.
 * @returns - Returns JSX element.
 */
export const ProductApplicationTableRow: React.FC<IProductApplicationTableRow> = ({ make, model, year, qualifier, className, note }) => {
    return(<tr className={className}>
        {/* <th scope='row'>
            <span dangerouslySetInnerHTML={getRichTextHtml(productName)} />
        </th> */}
        <td>
        <span dangerouslySetInnerHTML={getRichTextHtml(make)} />
        </td>
        <td>
        <span dangerouslySetInnerHTML={getRichTextHtml(model)} />
        </td>
        <td>
        <span dangerouslySetInnerHTML={getRichTextHtml(year)} />
        </td>
        <td>
        <ul>
            {qualifier?.sort().map((prod, index)=>{
              return prod && prod.length > 0 ?(<li key={index}>
                <span dangerouslySetInnerHTML={getRichTextHtml(prod)} />
              </li>) : undefined;
            })
        }
        </ul>
        </td>
        <td>
        <span dangerouslySetInnerHTML={getRichTextHtml(note)} />
        </td>
    </tr>
);};
